















































































































































import { AllGeeksSingleSelect } from '@/components';
import { RejectWithdrawalModal } from '@/components/admin-panel';
import { GeekItem } from '@/models';
import { GeeksWithdrawal, WaitingWithdrawalFilters, WaitingWithdrawalForm } from '@/models/admin-panel';
import { buildGeekName, ToastsService } from '@/utils';
import { collapseMixin, isWithdrawalsCollapseVisible } from '@/shared';
import { typedStore, Actions, Getters } from '@/store';
import Vue from 'vue';
import mixins from 'vue-typed-mixins';

export default mixins(collapseMixin).extend({
  name: 'WaitingWithdrawalsTab',
  components: {
    AllGeeksSingleSelect,
    RejectWithdrawalModal,
  },
  data() {
    return {
      withdrawalToReject: undefined as unknown as GeeksWithdrawal,
      filters: {
        immediate: {
          geekId: (null as unknown) as string,
        } as WaitingWithdrawalFilters,
      },
      loader: {
        isWaitingWithdrawalsListPending: false,
      },
    };
  },
  computed: {
    collapsibleItems(): GeeksWithdrawal[] {
      return typedStore(this).state.gCoins.waitingWithdrawals;
    },
    areMoreItemsAvailable(): boolean {
      return this.collapsibleItems.length < typedStore(this).state.gCoins.pagination.totalCount
        && this.collapsibleItems.length > 0;
    },
    filteredGeeks(): GeekItem[] {
      return typedStore(this).getters[Getters.geek.filtered];
    },
  },
  methods: {
    async fetchWaitingWithdrawals() {
      this.loader.isWaitingWithdrawalsListPending = true;
      try {
        await this.$store.dispatch(Actions.gCoins.fetchWaitingWithdrawals, this.filters.immediate);
      } finally {
        this.loader.isWaitingWithdrawalsListPending = false;
      }
    },
    async fetchMoreWaitingWithdrawals() {
      this.loader.isWaitingWithdrawalsListPending = true;
      try {
        await this.$store.dispatch(Actions.gCoins.fetchMoreWaitingWithdrawals, this.filters.immediate);
      } finally {
        this.loader.isWaitingWithdrawalsListPending = false;
      }
    },
    updateRequestedBy(selectedGeek: GeekItem) {
      this.filters.immediate.geekId = selectedGeek ? selectedGeek.id : (null as unknown) as string;
    },
    async acceptWithdrawal(waitingWithdrawal: GeeksWithdrawal) {
      this.loader.isWaitingWithdrawalsListPending = true;
      try {
        const fromData = {
          geekId: waitingWithdrawal.geek.id,
          transactionIds: waitingWithdrawal.transactions.map(e => e.id),
        } as WaitingWithdrawalForm;

        await this.$store.dispatch(Actions.gCoins.acceptWithdrawal, fromData);
        await this.$store.dispatch(Actions.gCoins.fetchWaitingWithdrawals, this.filters.immediate);

        const toastText = this.$t(
          'admin-panel.gcoins.tabs.waiting-withdrawals.accepted',
          { geekName: buildGeekName(waitingWithdrawal?.geek) },
        ) as string;
        ToastsService.success(toastText);
      } finally {
        this.loader.isWaitingWithdrawalsListPending = false;
      }
    },
    rejectWithdrawal(waitingWithdrawal: GeeksWithdrawal) {
      this.withdrawalToReject = waitingWithdrawal;
      this.$bvModal.show('reject-withdrawal-modal');
    },
    isWithdrawalsCollapseVisible,
    buildGeekName,
  },
  watch: {
    'filters.immediate': {
      handler(this: any) {
        this.fetchWaitingWithdrawals();
      },
      deep: true,
      immediate: true,
    },
  },
});
